const defaults = {
  easing: "ease",
  duration: 500,
  fill: "forwards"
};
const buildAnimation = ({
  frames,
  targetElement,
  timingOptions = {}
}) => {
  return targetElement.animate(frames, {
    ...defaults,
    ...timingOptions
  });
};
const getHeight = (element) => {
  return element.getBoundingClientRect().height;
};
const fireCustomEvent = ({
  oldStep,
  newStep,
  element,
  name
}) => {
  const event = new CustomEvent(name, {
    detail: {
      oldStep,
      newStep,
      element
    }
  });
  element.dispatchEvent(event);
};
const afterRepaint = (cb) => {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      cb();
    });
  });
};
const isMovingBackward = (direction) => {
  return direction === "backward";
};
const flip = (items) => {
  return [...items].reverse();
};
const defaultOptions = {
  stepIsValid: async (_step) => true,
  frames: [{ opacity: "0" }, { opacity: "1" }]
};
function Steppp(element, options = defaultOptions) {
  options = { ...defaultOptions, ...options };
  const stepWrapper = element.querySelector("[data-steppp-wrapper]") || element;
  const stepNodes = options.stepSelector ? stepWrapper.querySelectorAll(options.stepSelector) : stepWrapper.children;
  const steps = Array.from(stepNodes);
  const mergedOptions = { ...defaultOptions, ...options };
  const { stepIsValid } = mergedOptions;
  const getStep = (stepIndex = getActiveStepIndex()) => {
    return steps[stepIndex];
  };
  const getStepByName = (stepName = "") => {
    return steps.find((step) => step.dataset.stepppName === stepName);
  };
  const getActiveStepIndex = () => {
    return steps.findIndex((step) => step.dataset.stepppActive !== void 0) || 0;
  };
  const moveTo = (stepName) => moveStep({ stepName });
  const forward = () => moveStep();
  const backward = () => moveStep({ direction: "backward" });
  const animate = (args) => {
    args.timingOptions = options.timingOptions;
    return buildAnimation(args);
  };
  const queueAnimations = (oldStep, newStep, direction) => {
    const backward2 = isMovingBackward(direction);
    const { enter, exit } = animationFrames;
    const oldStepHeight = `${currentWrapperHeight}px`;
    const newStepHeight = `${calculateWrapperHeight(newStep)}px`;
    return [
      animate({
        frames: backward2 ? flip(exit) : exit,
        targetElement: backward2 ? newStep : oldStep
      }),
      animate({
        frames: backward2 ? flip(enter) : enter,
        targetElement: backward2 ? oldStep : newStep
      }),
      animate({
        frames: [
          {
            height: oldStepHeight
          },
          {
            height: newStepHeight
          }
        ],
        targetElement: stepWrapper
      })
    ];
  };
  const moveStep = async ({
    stepName = "",
    direction = "forward"
  } = {}) => {
    if (currentAnimations.length) {
      currentAnimations.map((a) => a.finish());
    }
    return new Promise((resolve) => {
      afterRepaint(async () => {
        const fallbackIncrementor = direction === "forward" ? 1 : -1;
        const oldActiveStep = getStep();
        const newActiveStep = getStepByName(stepName) || getStep(getActiveStepIndex() + fallbackIncrementor);
        const eventArgs = {
          oldStep: oldActiveStep,
          newStep: newActiveStep,
          element
        };
        if (direction === "forward" && !await stepIsValid(getStep())) {
          fireCustomEvent({
            ...eventArgs,
            name: "steppp:invalid"
          });
          return resolve();
        }
        if (!newActiveStep) {
          fireCustomEvent({
            ...eventArgs,
            name: "steppp:abort"
          });
          return resolve();
        }
        fireCustomEvent({
          ...eventArgs,
          name: "steppp:start"
        });
        afterRepaint(async () => {
          currentAnimations = queueAnimations(
            oldActiveStep,
            newActiveStep,
            direction
          );
          await Promise.all(currentAnimations.map((a) => a.finished));
          currentAnimations.forEach((a) => {
            a.commitStyles();
            a.persist();
          });
          currentAnimations = [];
          steps.forEach((s) => {
            delete s.dataset.stepppActive;
            heightObserver.unobserve(s);
            s.style.display = "none";
          });
          newActiveStep.style.display = "block";
          newActiveStep.dataset.stepppActive = "";
          heightObserver.observe(newActiveStep);
          fireCustomEvent({
            ...eventArgs,
            name: "steppp:complete"
          });
          return resolve();
        });
      });
    });
  };
  const calculateWrapperHeight = (step, height) => {
    element.style.height = "";
    step.style.display = "block";
    const newHeight = height || getHeight(step);
    currentWrapperHeight = newHeight;
    return newHeight;
  };
  const computeAnimationFrames = (frames) => {
    if (Array.isArray(frames)) {
      return {
        enter: frames,
        exit: [...frames.slice()].reverse()
      };
    }
    return frames;
  };
  const heightObserver = new ResizeObserver((entries) => {
    const entry = entries[0];
    if (!entry)
      return;
    const oldHeight = currentWrapperHeight;
    const { height: newHeight } = entry.contentRect;
    calculateWrapperHeight(entry.target, newHeight);
    animate({
      frames: [
        {
          height: `${oldHeight}px`
        },
        {
          height: `${newHeight}px`
        }
      ],
      targetElement: stepWrapper
    });
  });
  const animationFrames = computeAnimationFrames(options.frames);
  let currentAnimations = [];
  getStep().style.position = "absolute";
  const currentStepHeight = getHeight(getStep());
  stepWrapper.style.height = `${currentStepHeight}px`;
  let currentWrapperHeight = currentStepHeight;
  heightObserver.observe(getStep());
  element.querySelectorAll("[data-steppp-backward]").forEach((el) => {
    el.addEventListener("click", backward);
  });
  element.querySelectorAll("[data-steppp-forward]").forEach((el) => {
    el.addEventListener("click", forward);
  });
  element.querySelectorAll("[data-steppp-to]").forEach((el) => {
    el.addEventListener("click", () => {
      moveTo(el.dataset.stepppTo || "");
    });
  });
  return {
    backward,
    forward,
    moveTo
  };
}
export {
  Steppp as default
};
